import styled from '@emotion/styled';
import { Modal as ModalAnt } from 'antd';

export const Modal = styled(ModalAnt)`
  .ant-modal-content {
    padding: unset;

    .ant-modal-header {
      padding: 16px;
      height: 60px;
      border-bottom: 1px solid #e5e7eb;

      .ant-modal-title {
        font-size: 18px;
      }
    }

    .ant-modal-body {
      padding: 10px 16px 0 16px;
    }

    .ant-modal-footer {
      padding: 16px;
      height: 72px;
      margin: unset;
      border-top: 1px solid #e5e7eb;
    }
    &.full-width {
      width: 90vw;
    }
  }
`;
